import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { SplitText } from 'gsap/SplitText';
import { Observer } from 'gsap/Observer';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, SplitText, Observer);

export { gsap, ScrollTrigger, ScrollToPlugin, SplitText, Observer };
